import '.d{display:flex;}.ssr-plugin'
import '.i5{background-color:white;}.ssr-plugin'
import '.i1{border-radius:20px;}.ssr-plugin'
import '.a8{border:var(--border-subtle);}.ssr-plugin'
import '.ai{overflow:hidden;}.ssr-plugin'
import '.bm{padding:1rem;}.ssr-plugin'
import '.a4{width:100%;}.ssr-plugin'
import '.bn{align-items:flex-start;}.ssr-plugin'
import '.c9{background-color:var(--palette-blue-50);}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.f{align-items:center;}.ssr-plugin'
import '.i{justify-content:center;}.ssr-plugin'
import '.i6{width:6.1875rem;}.ssr-plugin'
import '.i7{height:7.6875rem;}.ssr-plugin'
import '.i8{border-radius:9px;}.ssr-plugin'
import '.a6{gap:0.5rem;}.ssr-plugin'
import { styled } from 'inlines'
import { Text } from '@app/components/core/typography/Text'
import Column from '@app/components/layout/Column'

export interface EventProps {
  date: number
  month: string
  category: string
  title: string
  description?: string
  time: string
  location: string
  onClick?: () => void
}

export const Event = ({
  date,
  month,
  category,
  title,
  description = '',
  time,
  location,
  onClick,
}: EventProps) => {
  return (
    <div className="d i5 i1 a8 ai bm a4 bn"
      onClick={onClick}
      style={{
        cursor: onClick ? 'pointer' : 'default',}}
    >
      {/* Date Section */}
      <div className="c9 bm d e f i i6 i7 i8"
      >
        <Text.Large
          style={{
            fontSize: '3.6rem',
            fontWeight: '700',
            color: 'var(--palette-blue-500)',
            lineHeight: '1',
            margin: 0,
          }}
          color="var(--palette-blue-500)"
        >
          {date}
        </Text.Large>
        <Text.ExtraSmall color="var(--palette-blue-500)">
          {String(month).toUpperCase()}
        </Text.ExtraSmall>
      </div>

      {/* Event Details Section */}
      <Column
        style={{
          padding: '0 1rem',
          flex: 1,
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          minHeight: '7.6875rem',
        }}
      >
        <div className="a6">
          {/* Category */}
          <Text.ExtraSmall
            isBold={true}
            style={{ marginBottom: '0.5rem' }}
            color="var(--brand-primary)"
          >
            {category.toUpperCase()}
          </Text.ExtraSmall>

          {/* Title */}
          <Text.Medium
            style={{
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              marginBottom: '0.5rem',
            }}
            color="var(--brand-secondary)"
          >
            {title}
          </Text.Medium>

          {/* Description */}
          <Text.Small
            style={{
              lineClamp: 2,
            }}
            color="var(--palette-blue-600)"
          >
            {description}
          </Text.Small>
        </div>
        {/* Time and Location - aligned to bottom */}
        <styled.div>
          <Text.ExtraSmall
            style={{
              marginTop: '0.5rem',
              WebkitLineClamp: 1,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: '-webkit-box',
              WebkitBoxOrient: 'vertical',
            }}
            color="var(--brand-secondary)"
          >
            {time} · {location}
          </Text.ExtraSmall>
        </styled.div>
      </Column>
    </div>
  )
}
